import { render, staticRenderFns } from "./fundDetail.vue?vue&type=template&id=39897ce6&scoped=true&"
import script from "./fundDetail.vue?vue&type=script&lang=js&"
export * from "./fundDetail.vue?vue&type=script&lang=js&"
import style0 from "./fundDetail.vue?vue&type=style&index=0&id=39897ce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39897ce6",
  null
  
)

export default component.exports